// extracted by mini-css-extract-plugin
export default {"redesignIssueBox":"EHhtW4qsLipd0pYbN6F9","redesignIssueWarning":"m0mdLZ6Oyw5SR8Fdip1S","redesignIssueError":"HchZN6_JUPm8B_xLq5yX","redesignIssueIcon":"GJP63yMZ64Kj8hQZverT"};